import * as React from "react";
import { CountDownBox, Time, CountDIcon } from "./styled";
import { PoolExtraFlashInfo } from "../../../../services/product";
import { formatSecToDate } from "views/utils/flashProduct";

const CountDown = ({ countInfo }: { countInfo: PoolExtraFlashInfo }) => {
	const [endTime, setEndTime] = React.useState<number>(+(countInfo?.countdownToEnd || 0));

	const tick = () => {
		setEndTime((preTime) => {
			return preTime - 1;
		});
	};
	React.useEffect(() => {
		const timerID = setInterval(() => {
			if (endTime > 0) {
				tick();
			}
		}, 1000);
		return () => clearInterval(timerID);
	});
	if (!countInfo?.countdownToEnd) {
		return null;
	}
	if (endTime <= 0) {
		return null;
	}
	return (
		<CountDownBox>
			<CountDIcon className={countInfo?.uiOptions?.icon} />
			<Time>{`Ends in ${formatSecToDate(endTime)}`}</Time>
		</CountDownBox>
	);
};

export default CountDown;
